<template>
  <div>
    <canvas v-if="type === 'ST7528'" ref="displaySt7528" width="1280" height="512" :style="{ width: displayWidth, height: displayHeight }"></canvas>
    <canvas v-if="type === 'NT7538'" ref="displayNt7538" width="1024" height="512" :style="{ width: displayWidth, height: displayHeight }"></canvas>
    <DisplayX1031 v-if="type === 'X1031'" ref="displayX1031" :bridge="bridge" :displayBuffer="displayBuffer" />
    <DisplayX1960 v-if="type === 'X1960'" ref="displayX1960" :bridge="bridge" :displayBuffer="displayBuffer" />
    <DisplayX19320 v-if="type === 'X19320'" ref="displayX19320" :bridge="bridge" :displayBuffer="displayBuffer" />
    <DisplayX19229 v-if="type === 'X19229'" ref="displayX19229" :bridge="bridge" :displayBuffer="displayBuffer" />
  </div>
</template>

<script>
import DisplayX1031 from '@/components/DisplayX1031';
import DisplayX1960 from '@/components/DisplayX1960';
import DisplayX19229 from '@/components/DisplayX19229';
import DisplayX19320 from '@/components/DisplayX19320';
// import logger from '@/logger';

export default {
  components: {
    DisplayX1031,
    DisplayX1960,
    DisplayX19229,
    DisplayX19320,
  },

  props: [
    'type',
    'bridge',
    'displayBuffer',
  ],

  data: () => ({
    displayWidth: '',
    displayHeight: '',
  }),

  watch: {
    displayBuffer() {
      if (this.type === 'ST7528') {
        this.updateSt7528();
      } else if (this.type === 'NT7538') {
        this.updateNt7538();
      }
    },
  },

  mounted() {
    process.nextTick(() => {
      const rect = this.$el.getBoundingClientRect();
      if (this.type === 'ST7528') {
        this.displayWidth = `${rect.width}px`;
        this.displayHeight = `${rect.width / 160 * 64}px`;
      } else {
        this.displayWidth = `${rect.width}px`;
        this.displayHeight = `${rect.width / 2}px`;
      }
    });
  },

  methods: {
    updateSt7528() {
      const elCanvas = this.$refs.displaySt7528;
      if (elCanvas) {
        const ctx = elCanvas.getContext('2d');

        ctx.save();

        try {
          ctx.clearRect(0, 0, elCanvas.width, elCanvas.height);

          const displayBuffer = this.bridge.getDisplayBuffer();

          ctx.scale(8, 8);

          for (let y = 0; y < 64; y++) {
            for (let x = 0; x < 160; x++) {
              const offset = ((y >> 3) * 160 + x) * 4;
              const mask = 1 << (y & 7);
              let color = 0;
              if (displayBuffer [offset + 0] & mask) {
                color |= 8;
              }
              if (displayBuffer [offset + 1] & mask) {
                color |= 4;
              }
              if (displayBuffer [offset + 2] & mask) {
                color |= 2;
              }
              if (displayBuffer [offset + 3] & mask) {
                color |= 1;
              }
              color = 255 - color * 17;
              ctx.fillStyle = `rgb(${color}, ${color}, ${color})`;
              ctx.fillRect(x, y, 1, 1);
            }
          }
        } finally {
          ctx.restore();
        }
      }
    },

    updateNt7538() {
      const elCanvas = this.$refs.displayNt7538;
      if (elCanvas) {
        const ctx = elCanvas.getContext('2d');

        ctx.save();

        try {
          ctx.clearRect(0, 0, elCanvas.width, elCanvas.height);

          const displayBuffer = this.bridge.getDisplayBuffer();

          ctx.scale(8, 8);

          ctx.fillStyle = '#000';

          for (let y = 0; y < 64; y++) {
            for (let x = 0; x < 128; x++) {
              const offset = (y >> 3) * 128 + x;
              const mask = 1 << (y & 7);
              if (displayBuffer [offset] & mask) {
                ctx.fillRect(x, y, 1, 1);
              }
            }
          }
        } finally {
          ctx.restore();
        }
      }
    },

    async getSrcCanvasFromSvgDisplay(display, width, heigth) {
      const svg = display.getDisplaySvg();
      const svgCanvas = document.createElement('canvas');
      svgCanvas.width = width;
      svgCanvas.height = heigth;

      const blob = new Blob([svg], { type: "image/svg+xml" });
      const url = URL.createObjectURL(blob);

      const img = new Image();
      const srcCanvas = await new Promise((resolve) => {
        img.onload = function () {
          const svgCtx = svgCanvas.getContext('2d');
          svgCtx.drawImage(img, 0, 0);
          URL.revokeObjectURL(url); // Clean up memory
          resolve(svgCanvas);
        };

        img.src = url;
      });

      return srcCanvas;
    },

    async generateScreenshot(drawBorderAroundScreenshot) {
      let srcCanvas = null;
      if (this.type === 'NT7538') {
        srcCanvas = this.$refs.displayNt7538;
      } else if (this.type === 'ST7528') {
        srcCanvas = this.$refs.displaySt7528;
      } else if (this.type === 'X1031') {
        srcCanvas = await this.getSrcCanvasFromSvgDisplay(this.$refs.displayX1031, 1000, 390);
      } else if (this.type === 'X1960') {
        srcCanvas = await this.getSrcCanvasFromSvgDisplay(this.$refs.displayX1960, 1000, 390);
      } else if (this.type === 'X19320') {
        srcCanvas = await this.getSrcCanvasFromSvgDisplay(this.$refs.displayX19320, 1000, 560);
      } else if (this.type === 'X19229') {
        srcCanvas = await this.getSrcCanvasFromSvgDisplay(this.$refs.displayX19229, 1000, 342);
      }

      if (!srcCanvas) {
        throw new Error('No display found');
      }
      const dstCanvas = document.createElement('canvas');
      dstCanvas.width = srcCanvas.width + 4;
      dstCanvas.height = srcCanvas.height + 4;

      const ctx = dstCanvas.getContext('2d');

      ctx.fillStyle = '#fff';
      ctx.fillRect(-0.5, -0.5, dstCanvas.width + 2, dstCanvas.height + 2);

      if (drawBorderAroundScreenshot) {
        ctx.strokeStyle = '#000';
        ctx.strokeRect(0.5, 0.5, dstCanvas.width - 1, dstCanvas.height - 1);
      }

      ctx.drawImage(srcCanvas, 2, 2);

      const dataUrl = dstCanvas.toDataURL();
      if (!dataUrl.startsWith('data:image/png;base64,')) {
        throw new Error(`Unexpected data URL format`);
      }
      const buffer = Buffer.from(dataUrl.slice(22), 'base64');

      return buffer;
    },
  },
};
</script>

<style>

</style>
